import { createFileRoute, notFound } from "@tanstack/react-router";

import { DocPage } from "@/pages/doc/doc-page";
import { publicDocsBySlug } from "@generated/public-manifest";
import { loadDocBody } from "@lib/doc-content";
import { injectedDocMeta } from "@lib/injected-doc-meta";

import type { DocMeta } from "@ming/shared";

function DocRoute() {
  const { doc, body } = Route.useLoaderData();

  return <DocPage doc={doc} body={body} />;
}

export const Route = createFileRoute("/d/$slug")({
  component: DocRoute,
  loader: async ({ params }) => {
    // Listed docs come from the public manifest; an unlisted link opened directly gets its
    // metadata injected server-side by the worker instead of a public bundle.
    const doc = publicDocsBySlug.get(params.slug) ?? injectedDocMeta<DocMeta>(params.slug);

    if (!doc) throw notFound();

    return { doc, body: await loadDocBody(params.slug) };
  },
});
